import { ReactNode } from 'react'

import { Form } from 'factorial-form'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'

import ContractFlowStep from 'modules/contracts/lib/ContractFlowStep'

class UpdateFlowStep extends ContractFlowStep {
  constructor(title: string, component: ReactNode, description?: string) {
    super(title, component, description)
  }

  trackNext(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.updateContractNext, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackBack(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.updateContractBack, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackSubmit(form: Form): void {
    track(trackingEvents.employee.contracts.updateContractSubmit, {
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackExit(step: number): void {
    track(trackingEvents.employee.contracts.updateContractExit, {
      step: step,
    })
  }
}

export default UpdateFlowStep
